import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../features/data-connector/redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import ParentContentCard from '../common/ParentContentCard';
import CustomSelect from '../../common/formElements/CustomSelect';
import CustomLoader from '../common/CustomLoader';
import { APP_WRITE } from 'drapcode-constant';
import { checkDataSourcePermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';
export class AppwriteDatabaseList extends Component {
  static propTypes = {
    dataConnector: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    selectedDatabase: '',
  };

  handleChange = (name, value) => {
    this.setState({ [name]: value });
  };
  handleSendRequset = async (value) => {
    const { actions, location, match, history } = this.props;
    const { state } = location;
    const { settingData, dataSourceName } = state;
    const { projectId, version } = match.params;
    await actions.getCollectionsByAppwrite({
      settingData,
      databaseId: this.state.selectedDatabase['value'],
      projectId,
      version,
    });

    const { collectionsByAppwrite } = this.props.dataConnector;
    const { collections } = collectionsByAppwrite;
    const transformedResult = collectionsByAppwrite
      ? collections.map((collection) => ({
          collectionName: collection.name,
          collectionId: collection.$id,
          fields: collection.attributes.reduce((fields, attribute) => {
            switch (attribute.type) {
              case 'string':
                fields[attribute.key] = 'text';
                break;
              case 'integer':
                fields[attribute.key] = 'number';
                break;
              case 'datetime':
                fields[attribute.key] = 'date';
                break;
              default:
                fields[attribute.key] = attribute.type;
            }
            return fields;
          }, {}),
        }))
      : [];
    const dataForSave = {
      name: dataSourceName,
      projectVersion: version,
      projectId,
      type: APP_WRITE,
      setting: settingData,
      completeData: {
        database: {
          id: this.state.selectedDatabase['value'],
          name: this.state.selectedDatabase['label'],
        },
        tables: transformedResult,
      },
    };
    console.log('setting here appwrite', settingData);
    const { 'X-Appwrite-Key': X_Appwrite_Key } = settingData;
    console.log('setting here appwrite X_Appwrite_Key', X_Appwrite_Key);
    await actions.saveDataInExternaldatabase(dataForSave);
    if (this.props.dataConnector.externalDbUuid) {
      const { externalDbUuid } = this.props.dataConnector;
      await actions.appwriteEnvironment({
        dataForSave,
        projectId,
        version,
        externalDatabaseId: externalDbUuid,
      });
      history.push(
        `/2.0/data-connector/${version}/v/${projectId}/appwrite-datasource/${externalDbUuid}`,
      );
    }
  };
  render() {
    const isAllowed = checkDataSourcePermission();
    if (!isAllowed) {
      return (
        <CommonPageComponent>
          <PermissionDenied message="Data Source" />
        </CommonPageComponent>
      );
    }
    const { dataConnector, match, history } = this.props;
    const { databaseByAppwrite, getCollectionsByAppwritePending } = dataConnector;

    const databases = databaseByAppwrite ? databaseByAppwrite.databases : null;
    if (databases == null) {
      const { projectId, version } = match.params;
      history.push(`/2.0/data-connector/${version}/v/${projectId}/appwrite-datasource`);
    }
    const dropdown = databases
      ? databases.map((item) => ({
          label: item.name,
          value: item.$id,
        }))
      : null;
    return (
      dropdown && (
        <CommonPageComponent>
          <ParentContentCard title={'Choose Database for Creating Collection'} icon="collection">
            <div className="row justify-content-center ">
              <div className="col-sm-4">
                <CustomSelect
                  name="selectedDatabase"
                  isMulti={false}
                  isObject={true}
                  options={dropdown}
                  onBlur={() => {}}
                  value={this.state.selectedDatabase}
                  placeholder="Select Database"
                  onChange={this.handleChange}
                />
              </div>
            </div>
            <div className="text-center ml-3 mt-2">
              <button
                className="btn btn-theme-submit mt-3"
                onClick={this.handleSendRequset}
                disabled={getCollectionsByAppwritePending}
              >
                <i className="wb webconnect-rocket"></i>
                &nbsp;Continue&nbsp;
                <CustomLoader loading={getCollectionsByAppwritePending} />
              </button>
            </div>
          </ParentContentCard>
        </CommonPageComponent>
      )
    );
  }
}

function mapStateToProps(state) {
  return {
    dataConnector: state.dataConnector,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AppwriteDatabaseList);
